/**
 * @generated SignedSource<<1eb3071f69f854654b6e5d4e530fc7e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NotificationSettingsForm_notificationCycles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "NotificationCycle",
  "abstractKey": null
};

node.hash = "3b8bc7e92dfa02ff7f7b3e72d96d5bce";

module.exports = node;
